import React, { useEffect, useState } from "react";
import { Modal, Button, Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setPdfModalOpen } from "../../../redux/actions/ApiCall/apiCall.js";

import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import combinationChart from "../../../assets/WidgetLibrary/combinationChart.svg";
import barChart from "../../../assets/WidgetLibrary/barChart.svg";
import horizontalBarChart from "../../../assets/WidgetLibrary/sideBarChart.svg";
import areaChart from "../../../assets/WidgetLibrary/areaChart.svg";
import lineChart from "../../../assets/WidgetLibrary/lineChart.svg";
import pieChart from "../../../assets/WidgetLibrary/pieChart.svg";
import doughnutChart from "../../../assets/WidgetLibrary/dounutChart.svg";
import bubbleChart from "../../../assets/WidgetLibrary/bubbleChart.svg";
import wordCloudChart from "../../../assets/WidgetLibrary/wordCloudChart.svg";
import histogram from "../../../assets/WidgetLibrary/Histogram.svg";
import gridChart from "../../../assets/WidgetLibrary/tableChart.svg";
import mapChart from "../../../assets/WidgetLibrary/mapChart.svg";
import heatmapChart from "../../../assets/WidgetLibrary/heatmapChart.svg";
import sunburstChart from "../../../assets/WidgetLibrary/sunburstChart.svg";
import numberChart from "../../../assets/WidgetLibrary/numberChart.svg";
import pivotChart from "../../../assets/WidgetLibrary/pivot.svg";
import postCardChart from "../../../assets/WidgetLibrary/postcard.svg";
import prolificLibraryIcon from "../../../assets/WidgetLibrary/prolific_libraryIcon.svg";
import Alert from "../../../assets/ppt/Alert.svg";

const PdfModal = ({
  onSubmitOk,
  totalPdfWidgets,
  unsupportedPdfWidgets,
  setAiInsightModal,
}) => {
  const dispatch = useDispatch();
  // const userPrivileges = useSelector(
  //   (state) => state?.ApiCall?.brands?.data?.result?.privileges
  // );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const authParams = useSelector((state) => state.Authentication.authParams);

  const [seeMore, setSeeMore] = useState(false);
  const [seeUnSupportedWidgets, setSeeUnSupportedWidgets] = useState(false);
  const isPdfModalOpen = useSelector((state) => state.ApiCall.isPdfModalOpen);
  const chartTypewithicon = {
    combination: combinationChart,
    bar: barChart,
    horizontalbar: horizontalBarChart,
    area: areaChart,
    line: lineChart,
    pie: pieChart,
    donut: doughnutChart,
    grid: gridChart,
    bubble: bubbleChart,
    wordcloud: wordCloudChart,
    kpi: numberChart,
    map: mapChart,
    heatmap: heatmapChart,
    sunburst: sunburstChart,
    histogram: histogram,
    postcard: postCardChart,
    pivotgrid: pivotChart,
    prolificuser: prolificLibraryIcon,
  };
  const shedString = (string, separator) => {
    //we split the string and make it free of separator
    const separatedArray = string?.split(separator);
    //we join the separatedArray with empty string
    const separatedString = separatedArray?.join("");
    return separatedString;
  };
  const handleCancel = (value) => {
    dispatch(setPdfModalOpen(false));
  };

  const handleOK = () => {
    if (workspace_privileges?.ai_insights_ppt_pdf) {
      setAiInsightModal(true);
      dispatch(setPdfModalOpen(false));
    } else {
      onSubmitOk(false);
    }
  };

  return (
    <>
      <Modal
        title={null}
        visible={isPdfModalOpen}
        onCancel={handleCancel}
        width={760}
        className={`chart_list-modal ${
          authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
        }`}
        footer={
          <Button
            type="primary"
            onClick={handleOK}
            className="ant-btn-primary_blue"
          >
            Download PDF
          </Button>
        }
      >
        <div
          className={
            unsupportedPdfWidgets && unsupportedPdfWidgets?.length > 0
              ? ""
              : "d-none"
          }
        >
          <div className="text_heading d-flex align-items-center fontSize-16 mb-2 font-weight500">
            <img
              src={Alert}
              alt="alert"
              className="mr-15"
              style={{ maxWidth: "4rem" }}
            />
            <div>
              <span className="line-height-normal text-transform__none d-block pr-4">
                {unsupportedPdfWidgets?.length === 1
                  ? "Bubble chart present in this dashboard is not supported in PDF report. These widgets will be skipped."
                  : `Bubble chart present in this dashboard is not supported in PDF report. These widgets will be skipped.`}
              </span>
            </div>
          </div>

          {/* Code Commented for bubble chart, want to show only message */}
          {/* <div
            className={`d-flex flex-wrap align-items-start flex-wrap mt-4`}
          >
            {unsupportedPdfWidgets?.length > 0 ? (
              unsupportedPdfWidgets.map((el, i) => {
                return (
                  <div
                    style={{ width: "12.4rem" }}
                    className="border border-color border-radius-4 text-center mb-15 mr-15 pt-2 pb-2"
                  >
                    {chartTypewithicon[
                      shedString(el?.graph_type, "-")?.toLowerCase()
                    ] ? (
                      <img
                        src={
                          chartTypewithicon[
                            shedString(el?.graph_type, "-")?.toLowerCase()
                          ]
                        }
                        alt={el?.graph_type}
                        style={{
                          maxWidth: "100%",
                          height: "6rem",
                        }}
                        className="mb-2"
                      />
                    ) : (
                      <img
                        src={somethingWentWrong}
                        alt={el?.graph_type}
                        style={{
                          maxHeight: "100%",
                          width: "6rem",
                        }}
                        className="mb-2"
                      />
                    )}
                    <div className="text_regular text-ellipsis pl-2 pr-2 line-height-normal pt-2 border-top border-color">
                      <Tooltip title={el?.widget_name}>
                        {el?.widget_name}
                      </Tooltip>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="w-100 text-center mb-15">
                <img
                  src={somethingWentWrong}
                  alt={somethingWentWrong}
                  style={{
                    height: "10rem",
                    width: "10rem",
                  }}
                />
                <div className="text_regular-gray">No Data Found</div>
              </div>
            )}
          </div> */}
        </div>
      </Modal>
    </>
  );
};

export default PdfModal;
